<template>
<div class="pd_show_qty_wrap">
    <span class="t_color">數量</span>
    <div class="qty_cart_wrap">
       <div class="qty">
           <a href="#" @click.prevent="minus">-</a>
           <span class="qty-num">{{ qty }}</span>
           <a href="#" @click.prevent="add">+</a>
       </div>
       <a href="#" class="cart_btn" @click.prevent="addCart">
           放入購物車
       </a>
    </div>
</div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      qty: 1
    };
  },
  methods: {
    add() {
      this.qty++;
    },

    minus() {
      if (this.qty > 1) {
        this.qty--;
      }
    },

    addCart() {
      eventHub.$emit("addCart", { id: this.id, qty: this.qty });
    },

    directAddCart() {
      eventHub.$emit("directAddCart", { id: this.id, qty: this.qty });
    }
  }
};
</script>
